export default __webpack_public_path__ + "static/media/gb.bef581ce.png";